module.exports = __webpack_public_path__ + "yz/media/onselfOwe.46f5c29e.mp3";